import { Pressable, StyleSheet, View } from "react-native";
import { PlaceColors } from "../helpers/PlaceColors";
import React, { useContext } from "react";
import { FindifyBasicModal } from "./FindifyBasicModal";
import { FindifyDataContext } from "@/contexts/FindifyDataContext";
import { PlaceText } from "./PlaceText";

type FindifyDialogProps = {
    onAction1: () => void;
    onAction2?: () => void;
    action1Text: string;
    action2Text?: string;
    message: string;
}

export const FindifyDialog = ({
    onAction1,
    onAction2,
    action1Text,
    action2Text,
    message
}: FindifyDialogProps) => {
    const findifyDataContext = useContext(FindifyDataContext);
    return <FindifyBasicModal isOpen={true} closeModal={() => { }}>
        <View style={{ padding: 25 }}>
            <PlaceText style={[modalStyle.modalText]} >{message}</PlaceText>
            <View style={{ display: 'flex', flexDirection: 'row', gap: 14 }}>
                {action2Text != null &&
                    <Pressable
                        onPressIn={onAction1}
                        style={[modalStyle.button, { backgroundColor: PlaceColors(findifyDataContext).primary.withAlpha(100) }]}
                    >
                        <PlaceText style={[modalStyle.buttonText,]} >{action1Text}</PlaceText>
                    </Pressable>}
                {action2Text != null &&
                    <Pressable
                        onPressIn={onAction2}
                        style={[modalStyle.button, { backgroundColor: PlaceColors(findifyDataContext).primary.withAlpha(200) }]}
                    >
                        <PlaceText style={[modalStyle.buttonText,]} >{action2Text}</PlaceText>
                    </Pressable>}
            </View>
        </View>
    </FindifyBasicModal >

}



const modalStyle = StyleSheet.create({
    button: {
        fontSize: 16,
        padding: 5,
        borderRadius: 6,
    },
    buttonText: {
        fontSize: 16,
        padding: 5,
        borderRadius: 10,
    },
    modalText: {
        fontSize: 20,
        paddingBottom: 10
    },

})